"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var FleetRouterEntity_1 = __importDefault(require("./Entity/FleetRouterEntity"));
var FleetRouterApi = /** @class */ (function () {
    function FleetRouterApi(session) {
        this.fleetRouterEntity = new FleetRouterEntity_1.default(session);
    }
    FleetRouterApi.prototype.getAll = function () {
        return this.fleetRouterEntity.service.getAll();
    };
    FleetRouterApi.prototype.create = function (params) {
        return this.fleetRouterEntity.service.create(params);
    };
    FleetRouterApi.prototype.update = function (id, params) {
        return this.fleetRouterEntity.service.update(id, params);
    };
    FleetRouterApi.prototype.delete = function (id) {
        return this.fleetRouterEntity.service.delete(id);
    };
    FleetRouterApi.prototype.patch = function (params) {
        return this.fleetRouterEntity.service.patch(undefined, params);
    };
    return FleetRouterApi;
}());
exports.default = FleetRouterApi;
//# sourceMappingURL=FleetRouterApi.js.map